const DamClient = require("./DamClient");
const DamPrefix = require("./prefixes/DamPrefix");

module.exports = { 
	DamClient,
	DamPrefix 
}
